import React from "react";
import { Error } from "components/chrome/main_view/info_messages";

export const PageNotFound = () => {
  return <Error title="Page Not Found">The page could not be found.</Error>;
};
